import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const GET_BENUTZER_BERECHTIGUNGEN_ADMIN = '[BenutzerverwaltungModul] GetBenutzerBerechtigungenAdmin laden';
export const GET_BENUTZER_BERECHTIGUNGEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] GetBenutzerBerechtigungenAdmin ausführen';
export const GET_BENUTZER_BERECHTIGUNGEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] GetBenutzerBerechtigungenAdmin laden erfolgreich';
export const GET_BENUTZER_BERECHTIGUNGEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] GetBenutzerBerechtigungenAdmin Ladefehler';
export const GET_BENUTZER_BERECHTIGUNGEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetBenutzerBerechtigungenAdmin nicht ausgeführt (evtl. Offline)';


export class GetBenutzerBerechtigungenAdminAction implements Action {
    readonly type = GET_BENUTZER_BERECHTIGUNGEN_ADMIN;
        constructor( public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerBerechtigungenAdminAusfuehrenAction implements Action {
    readonly type = GET_BENUTZER_BERECHTIGUNGEN_ADMIN_AUSFUEHREN;
        constructor( public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerBerechtigungenAdminErfolgreichAction implements Action {
    readonly type = GET_BENUTZER_BERECHTIGUNGEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerBerechtigungenForAdmin,  public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerBerechtigungenAdminFehlerAction implements Action {
    readonly type = GET_BENUTZER_BERECHTIGUNGEN_ADMIN_FEHLER;
        constructor(public payload: any,  public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerBerechtigungenAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_BENUTZER_BERECHTIGUNGEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryBenutzerBerechtigungenAdminActions =
    GetBenutzerBerechtigungenAdminAction
    | GetBenutzerBerechtigungenAdminAusfuehrenAction
    | GetBenutzerBerechtigungenAdminErfolgreichAction
    | GetBenutzerBerechtigungenAdminFehlerAction
    | GetBenutzerBerechtigungenAdminNichtAusgefuehrtAction
    ;
